import { Component, Input, OnInit } from '@angular/core';

const texts = {
  phasesText: `To re-order the phases below, hover over a row until the drag icon appears. Then click and hold to
move the row to the desired location. Confirm by selecting the “Update Order” button.`,
  elevationsText: `To re-order the elevations below, hover over a row until the drag icon appears. Then click and hold to
  move the row to the desired location. Confirm by selecting the “Update Order” button.`,
  homeGalleryText: `To re-order the photos below, hover over a row until the drag icon appears. Then click and hold to
  move the row to the desired location. Confirm by selecting the “Update Order” button.`
};
@Component({
  selector: 'tp-reorder-hint',
  templateUrl: './reorder-hint.component.html',
  styleUrls: ['./reorder-hint.component.scss']
})
export class ReorderHintComponent implements OnInit {
  @Input() reorderHintTextKey = 'phasesText';
  reorderHintText: string;

  constructor() {}

  ngOnInit(): void {
    this.reorderHintText = texts[this.reorderHintTextKey];
  }
}
